import React from 'react';
import './customFormComponents.scss';

export const PageTitleHeader = ({ className, title, ...otherProps }) => (
  <h2 className={`${className ?? ''} page-title`} {...otherProps}>
    <b>{title}</b>
  </h2>
);
